import { createSharedComposable, useEventBus } from "@vueuse/core";
export const FilterDataEvent = Symbol("filter-data-bus");
export const useFilterBus = createSharedComposable(() =>
  useEventBus<string>(FilterDataEvent)
);
